import { render, staticRenderFns } from "./CardInfoTicketA.vue?vue&type=template&id=778b0a5c&lang=true"
import script from "./CardInfoTicketA.vue?vue&type=script&lang=js"
export * from "./CardInfoTicketA.vue?vue&type=script&lang=js"
import style0 from "./CardInfoTicketA.vue?vue&type=style&index=0&id=778b0a5c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports